class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.externalEls?.details?.exists || !this.externalEls?.form?.exists) {
      return
    }

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '0px',
      threshold: 0,
    })

    if (window.matchMedia('(min-width: 768px)').matches) {
      this.observer.observe(this.externalEls.details.element)
    } else {
      this.observer.observe(this.externalEls.form.element)
    }

    if (!this.externalEls?.footer?.exists) return

    this.observer.observe(this.externalEls.footer.element)
  }

  setupListeners () {
    super.setupListeners()

    if (
      this.els['mto-customise-button']?.exists !== true ||
      this.externalEls['mto-trigger']?.exists !== true
    ) {
      return
    }

    this.listeners.add(
      this.els['mto-customise-button'].element,
      'click',
      this.handleClick.bind(this),
    )
  }

  findFirstTrigger () {
    return this.externalEls['mto-trigger']?.elements.find((el) => {
      return (
        !el.parentElement.hasAttribute('hidden') &&
        el.parentElement.hasAttribute('data-made-to-order-item-key')
      )
    })
  }

  handleClick () {
    const firstTrigger = this.findFirstTrigger()
    if (!firstTrigger) return

    const headerHeight = window
      .getComputedStyle(document.body)
      .getPropertyValue('--Header_Height')

    window.addEventListener(
      'scrollend',
      () => {
        firstTrigger.click()
        firstTrigger.style.scrollMargin = ''
      },
      { once: true },
    )

    firstTrigger.style.scrollMargin = headerHeight || 0
    firstTrigger.scrollIntoView()
  }

  onEntry ([entry], observer) {
    this.setAttribute('aria-hidden', entry.isIntersecting)
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
